import Card from "./components/Card";
import Header from "./components/Header";

function App() {
  return (
    <div>
      <Header />
      <Card />
    </div>
  );
}

export default App;
